import { createStore, applyMiddleware } from 'redux'
import rootReducer from 'redux/reducers'
import thunkMiddleware from 'redux-thunk'

export const store = createStore(rootReducer, applyMiddleware(thunkMiddleware))


// WEBPACK FOOTER //
// ./src/redux/store/index.js